import axios from 'axios';
import AOS from 'aos'
import Vue from 'vue'
import { klaroConfig } from './utils/klaroConfig';

window.axios = axios;
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

/**
 * Vue
 */
window.Vue = Vue;

/**
 * AOS
 */
window.AOS = AOS;

/**
 * Klaro Consent Tool
 */
window.klaroConfig = klaroConfig;
const klaro = require('klaro');
window.klaro = klaro;
